export default {
	'home.accountConfigurationProgress': 'Your account configuration is <i>%{progress}% Complete</i>',
	'home.browseLocalTalent': "Browse local talent that meets your company’s requirements with our <a href='/search' target='_blank'>Worker Search Engine.</a>",
	'home.createAssignments': 'Create Assignments',
	'home.createAssignmentsContent': 'Create an assignment, upload multiple assignments in bulk, or create a project with multiple assignments.',
	'home.curateTalentPools': 'Curate Labor Clouds',
	'home.curateTalentPoolsContent': 'Curate groups of pre-selected talent for future assignments.',
	'home.customizeYourBackground': 'Customize your background',
	'home.findTalent': 'Find Talent',
	'home.findTalentContent': 'Invite your current freelancers or browse the talent marketplace to find the right talent for the job.',
	'home.fromYourHomePage': 'From your home page you have access to all of the WorkMarket features from the four center tiles.',
	'home.letsGetStarted:': "Let's get started!",
	'home.navigation': 'Navigation',
	'home.paymentCenter': 'Payment Center',
	'home.paymentCenterContent': 'Configure your payment settings, view invoices, and manage your funds.',
	'home.paymentCenterButton': 'Fund Your Account',
	'home.pendingInvitations': 'You have %{invitationsCount} pending Labor Cloud invitations.',
	'home.viewInvitations': 'View Invitations',
	'home.welcomeToWorkMarket': 'WELCOME TO WORKMARKET',
	'home.welcomeToWorkMarketName': 'Welcome to WorkMarket, %{firstName}',
	'home.workMarketIs': 'WorkMarket is the #1 freelancer management solution. Use it to find and manage freelancers, contractors and consultants.',
	'home.youCanAlsoNavigate': 'You can also navigate via this orange button.'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/home.js